<template>
  <div class="content">
    <van-field 
      v-model="merNo" 
      label="切换商户号" 
      placeholder="请选择商户号"  
      readonly  
      right-icon="arrow"
      @click="isShowMerNo = true"
    />
    <div class="top-content">
      <div class="banner-box">
        <div class="top-box">
          <span>待提现余额(元)</span>
          <span class="money">¥{{ customerUnionSum.unionBalance || 0}}</span>
          <span class="earnest-money">冻结保证金：¥{{ customerUnionSum.frozenMarginAmount || 0 }}</span>
        </div>
        <div class="bottom-box" v-if="!dateParmes.startDate">
          待提现余额 = 已结算金额 - 待核销金额 - 已提现金额 – 保证金
        </div>
      </div>
      <div class="card-box">
        <div class="item" :class="{active: type == 1}" @click="changeType(1)">
          <span class="money">¥{{ customerUnionSum.totalAmount || 0}}</span>
          <span class="title">已结算金额</span>
        </div>
        <div class="item" :class="{active: type == 2}" @click="changeType(2)">
          <span class="money">¥{{ customerUnionSum.waitVerifyAmount || 0 }}</span>
          <span class="title">待核销金额</span>
        </div>
        <div class="item" :class="{active: type == 3}" @click="changeType(3)">
          <span class="money">¥{{ customerUnionSum.refundAmount || 0 }}</span>
          <span class="title">已退款金额</span>
        </div>
        <div class="item" :class="{active: type == 4}" @click="changeType(4)">
          <span class="money">¥{{ customerUnionSum.extractedCash || 0 }}</span>
          <span class="title">已提现金额</span>
        </div>
      </div>
      <div class="title-box">
        <div class="top-box">
          <span class="title">{{ mapTitle[type].title }}</span>
          <span class="export" @click="exportFile">导出数据 ></span>
        </div>
        <div class="subtitle">{{ mapTitle[type].subtitle }}</div>
      </div>
    </div>

    <van-sticky>
      <div class="list-box">
        <mescroll-vue
          ref="mescroll"
          :down="mescrollDown"
          :up="mescrollUp"
          class="scroll"
          @init="mescrollInit"
        >
          <div id="content" class="list-content">
            <div class="row" v-for="(item, index) in list" :key="index">
              <div class="row-top">
                <span>{{ item.userName }} {{ item.userPhone }}</span>
                <span>¥{{ item.settlementAmount }}</span>
              </div>
              <div class="row-bottom" v-if="type == 1">核销时间 {{ item.verificationTime }}</div>
              <div class="row-bottom" v-else-if="type == 2">下单时间 {{ item.buyTime }}</div>
              <div class="row-bottom" v-else-if="type == 3">退款时间 {{ item.refundTime }}</div>
              <div class="row-bottom" v-else-if="type == 4">提现时间 {{ item.buyTime }}</div>
            </div> 
          </div>
        </mescroll-vue>
      </div>
    </van-sticky>
    <unionpay-pop  />
    <van-popup v-model="isShowMerNo" position="bottom" >
      <van-picker
        title="商户号选择"
        show-toolbar
        :columns="customerMerNoList"
        @confirm="onConfirm"
        @cancel="isShowMerNo = false"
      />
    </van-popup>
  </div>
</template>

<script>
  import MescrollVue from 'mescroll.js/mescroll.vue'
  import unionpayPop from './unionpay-pop.vue'
  import noDataImg from "@/assets/images/img-default@2x.png";
  export default {
    components: { MescrollVue,unionpayPop },
    props: {
      dateParmes: {
        type: Object,
        default() {
          return {}
        }
      },
    },
    data() {
      return {
        mescroll: null,
        mescrollDown: {
          callback: this.init,
          auto: false,
        },
        mescrollUp: {
          callback: this.getList,
          page: {
            num: 1,
            size: 10
          },
          htmlNodata: '<p class="upwarp-nodata">-- 没有更多数据了 --</p>',
          noMoreSize: 1,
          auto: false,
          empty: {
            // 列表第一页无任何数据时,显示的空提示布局; 需配置warpId才生效;
            warpId: 'content', // 父布局的id;
            icon: noDataImg, // 图标,支持网络图
            tip: '暂无数据', // 提示
          },
        },
        list: [],
        customerUnionSum: {},
        type: 1,
        isClick: true,
        mapTitle: {
          1: {title: '已结算金额订单明细', subtitle: '(不含今日新增报名订单、不含已退款订单)'},
          2: {title: '待核销金额订单明细', subtitle: '(报名时间在筛选时间内的未核销订单，但不包含今日新增报名订单)'},
          3: {title: '已退款金额订单明细', subtitle: '(退款时间在筛选时间内的所有已退款订单)'},
          4: {title: '已提现金额记录明细'},
        },
        isShowMerNo: false,
        customerMerNoList: [],
        merNo: ''
      }
    },
    mounted() {
      this.queryCustomerMerNoList()
      // this.queryCustomerUnionSum()
    },
    methods: {
      init() {
        this.list = []
        // 下拉刷新的回调; 默认重置上拉加载列表为第一页
        this.mescroll.resetUpScroll()
      },
      mescrollInit(mescroll) {
        this.mescroll = mescroll
      },
      queryCustomerMerNoList() {
        this.$api.withdrawal.queryCustomerMerNoList()
          .then(res => {
            if (res.data && res.data.length) {
              this.customerMerNoList = res.data
              this.merNo = this.customerMerNoList [0]
              this.queryCustomerUnionSum()
              this.init()
            }
          })
      },
      queryCustomerUnionSum() {
        this.$api.withdrawal.queryCustomerUnionSum({
          ...this.dateParmes,
          merNo: this.merNo
        })
          .then(res => {
            if (res.data) {
              this.customerUnionSum = res.data
            }
          })
      },
      getList(page, mescroll) {
        const parames = {
          filterData: {
            type: this.type,
            ...this.dateParmes,
            merNo: this.merNo 
          },
          pageNum: page.num,
          pageSize: page.size,
        }
        this.$api.withdrawal.queryCustomerUnionOrderList(parames)
          .then(res => {
            if (res.success) {
              const {list, hasNextPage } = res.data
              this.list.push(...list);
              mescroll.endSuccess(this.list.length, hasNextPage)
            } 
          })
      },
      onConfirm(merNo) {
        this.merNo = merNo
        this.isShowMerNo = false
        this.dateSearch()
      },
      changeType(type) {
        this.type = type 
        this.list = []
        this.pageNum = 1
        this.finished = false
        this.init()
      },
      dateSearch() {
        this.list = []
        this.pageNum = 1
        this.finished = false
        this.$nextTick(() =>{
          this.queryCustomerUnionSum()
          this.init()
        })
      },
      exportFile() {
        if (this.isClick){
          let map = { 1: 10, 2: 11, 3: 12, 4: 13 }
          this.isClick = false
          const { startDate = '',endDate = '' } = this.dateParmes
          const parames = {
            type: map[this.type],
            startTime: startDate,
            endTime: endDate,
            merNo: this.merNo 
          }
          this.$api.activityMgmt.dataExport(parames)
            .then((res) => {
              if (res.success) {
                this.$dialog.confirm({
                  title: '下载提示',
                  message:`因数据较大正在处理中，请稍后到<br/>我的-导出列表中下载数据`,
                  cancelButtonText: '确定',
                  confirmButtonText: '去往-导出列表'
                }).then(_ =>{
                  this.$router.push({
                    path: '/export-list'
                  })
                })
              }
            }).finally(_ => {
              setTimeout(() => {
                this.isClick = true
              },500)
            })
        }
      },
    }
  }
</script>

<style lang="stylus" scoped>
  .content {
    .top-content {
      padding: 0 15px;
      .banner-box {
        width: 100%;
        min-height: 170px;
        border-radius: 13px;
        margin-top: 15px;
        background: #F4F4F4;
        .top-box {
          display: flex;
          flex-direction: column;
          justify-content: center;
          font-size: 17px;
          color: #fff;
          width: 100%;
          height: 133px;
          padding-left: 20px
          box-sizing border-box
          background: url("https://img3.quanyou.com.cn/joyNew/group1/M00/46/D7/rB8LrmZZbxiAAXgDAADfGeLPI08949.png");
          background-size: 100% 100%;
          .money {
            font-size: 27px;
            font-weight: bold;
            margin: 6px 0;
          }
          .earnest-money {
            color: #FFE4E4;
            font-size: 15px;
          }
        }
        .bottom-box {
          color: #666666;
          font-size: 12px;
          white-space: pre-wrap;
          line-height: 20px;
          padding: 6px;
          // width: 300px;
          // background: red
        }
      }
      .card-box {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap; 
      
        .item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 165px;
          height: 86px;
          background: #F4F4F4;
          border-radius: 13px;
          margin-top: 15px;
          border: 1px solid transparent;
          .money {
            font-size: 20px;
            font-weight: bold;
          }
          .title {
            color: 16px;
            margin-top: 2px;
          }
        }
        .active {
          color: #FF6B31;
          border: 1px solid #FF6B31;
          background: #FFF2ED;
        }
      }
      .title-box {
        padding: 8px 0;
        height: 40px;
        margin-top: 8px;
        .top-box {
          display: flex;
          justify-content: space-between;
          font-size: 15px;
          .title {
            color: #333333;
            font-weight: 500;
          }
          .export {
            color: #666666;
          }
        }
        .subtitle {
          font-size: 12px;
          margin-top: 4px;
        }
       
      }
    }
    .list-box {
      padding: 0 15px;
      height: 91vh;
      overflow-y: auto;
      background: #fff;
      .list-content {
        .row {
          padding: 15px 0;
          border-bottom: 1px solid #E5E5E5;
          .row-top {
            display: flex;
            justify-content: space-between;
            color: #333333;
            font-size: 16px;
          }
          .row-bottom {
            color: #999999;
            font-size: 13px;
            margin-top: 3px;
          }
        }
      }
    }
  }
</style>